import { render, staticRenderFns } from "./MsGoodsAddOrEdit.vue?vue&type=template&id=3ceea6e0&scoped=true&"
import script from "./MsGoodsAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./MsGoodsAddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceea6e0",
  null
  
)

export default component.exports